// extracted by mini-css-extract-plugin
module.exports = {"group":"CheckboxGroup_group__WiPow","legend":"CheckboxGroup_legend__2Y-At","error":"CheckboxGroup_error__3P2Jr"};